import type { FC } from "react";
import TemplateCard from "./TemplateCard";

interface TemplateShowcaseProps {
  templates: Array<{
    id: number;
    title: string;
    imageUrl: string;
    description: string;
  }>;
}

const TemplateShowcase: FC<TemplateShowcaseProps> = ({ templates }) => {
  return (
    <div className="container mx-auto px-4">
      <ol className="grid grid-cols-1 gap-4 p-0 sm:grid-cols-2 md:grid-cols-3">
        {templates.map((template) => (
          <TemplateCard
            key={template.id}
            title={template.title}
            imageUrl={template.imageUrl}
            description={template.description}
          />
        ))}
      </ol>
    </div>
  );
};

export default TemplateShowcase;
